import {all, call, fork, put, takeEvery} from 'bukku/shared/SagaService';
import {message} from 'antd';
import actions from './actions';
import {get} from 'bukku/shared/ApiService';

// Read all
export function* allRequest() {
    yield takeEvery(actions.DASHBOARD_ALL_REQUEST, function* (payload, context) {
        try {
            const response = yield call(get, '/dashboard/all', null, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.DASHBOARD_ALL_SUCCESS,
                data,
            });
        }
        catch (error) {
            yield put({
                type: actions.DASHBOARD_ALL_ERROR,
                error,
            });
        }
    });
}
export function* allSuccess() {
    yield takeEvery(actions.DASHBOARD_ALL_SUCCESS, () => {});
}
export function* allError() {
    yield takeEvery(actions.DASHBOARD_ALL_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Outstandings
export function* outstandingsRequest() {
    yield takeEvery(actions.DASHBOARD_OUTSTANDINGS_REQUEST, function* (payload, context) {
        try {
            const response = yield call(get, '/dashboard/outstandings', null, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.DASHBOARD_OUTSTANDINGS_SUCCESS,
                data,
            });
        }
        catch (error) {
            yield put({
                type: actions.DASHBOARD_OUTSTANDINGS_ERROR,
                error,
            });
        }
    });
}
export function* outstandingsSuccess() {
    yield takeEvery(actions.DASHBOARD_OUTSTANDINGS_SUCCESS, () => {});
}
export function* outstandingsError() {
    yield takeEvery(actions.DASHBOARD_OUTSTANDINGS_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Sales trend
export function* salesTrendRequest() {
    yield takeEvery(actions.DASHBOARD_SALES_TREND_REQUEST, function* ({ request }, context) {
        try {
            const response = yield call(get, '/dashboard/sales_trend', request, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.DASHBOARD_SALES_TREND_SUCCESS,
                data,
            });
        }
        catch (error) {
            yield put({
                type: actions.DASHBOARD_SALES_TREND_ERROR,
                error,
            });
        }
    });
}
export function* salesTrendSuccess() {
    yield takeEvery(actions.DASHBOARD_SALES_TREND_SUCCESS, () => {});
}
export function* salesTrendError() {
    yield takeEvery(actions.DASHBOARD_SALES_TREND_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Profit loss trend
export function* profitLossTrendRequest() {
    yield takeEvery(actions.DASHBOARD_PROFIT_LOSS_TREND_REQUEST, function* ({ request }, context) {
        try {
            const response = yield call(get, '/dashboard/profit_loss_trend', request, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.DASHBOARD_PROFIT_LOSS_TREND_SUCCESS,
                data,
            });
        }
        catch (error) {
            yield put({
                type: actions.DASHBOARD_PROFIT_LOSS_TREND_ERROR,
                error,
            });
        }
    });
}
export function* profitLossTrendSuccess() {
    yield takeEvery(actions.DASHBOARD_PROFIT_LOSS_TREND_SUCCESS, () => {});
}
export function* profitLossTrendError() {
    yield takeEvery(actions.DASHBOARD_PROFIT_LOSS_TREND_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Cashflow trend
export function* cashflowTrendRequest() {
    yield takeEvery(actions.DASHBOARD_CASHFLOW_TREND_REQUEST, function* ({ request }, context) {
        try {
            const response = yield call(get, '/dashboard/cashflow_trend', request, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.DASHBOARD_CASHFLOW_TREND_SUCCESS,
                data,
            });
        }
        catch (error) {
            yield put({
                type: actions.DASHBOARD_CASHFLOW_TREND_ERROR,
                error,
            });
        }
    });
}
export function* cashflowTrendSuccess() {
    yield takeEvery(actions.DASHBOARD_CASHFLOW_TREND_SUCCESS, () => {});
}
export function* cashflowTrendError() {
    yield takeEvery(actions.DASHBOARD_CASHFLOW_TREND_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Cashflow forecast
export function* cashflowForecastRequest() {
    yield takeEvery(actions.DASHBOARD_CASHFLOW_FORECAST_REQUEST, function* ({ request }, context) {
        try {
            const response = yield call(get, '/dashboard/cashflow_forecast', request, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.DASHBOARD_CASHFLOW_FORECAST_SUCCESS,
                data,
            });
        }
        catch (error) {
            yield put({
                type: actions.DASHBOARD_CASHFLOW_FORECAST_ERROR,
                error,
            });
        }
    });
}
export function* cashflowForecastSuccess() {
    yield takeEvery(actions.DASHBOARD_CASHFLOW_FORECAST_SUCCESS, () => {});
}
export function* cashflowForecastError() {
    yield takeEvery(actions.DASHBOARD_CASHFLOW_FORECAST_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Bank accounts
export function* bankAccountsRequest() {
    yield takeEvery(actions.DASHBOARD_BANK_ACCOUNTS_REQUEST, function* ({ preset }, context) {
        try {
            const response = yield call(get, '/dashboard/bank_accounts', { preset }, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.DASHBOARD_BANK_ACCOUNTS_SUCCESS,
                data,
            });
        }
        catch (error) {
            yield put({
                type: actions.DASHBOARD_BANK_ACCOUNTS_ERROR,
                error,
            });
        }
    });
}
export function* bankAccountsSuccess() {
    yield takeEvery(actions.DASHBOARD_BANK_ACCOUNTS_SUCCESS, () => {});
}
export function* bankAccountsError() {
    yield takeEvery(actions.DASHBOARD_BANK_ACCOUNTS_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Sales list
export function* salesListRequest() {
    yield takeEvery(actions.DASHBOARD_SALES_LIST_REQUEST, function* (payload, context) {
        try {
            const response = yield call(get, '/dashboard/sales_list', null, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.DASHBOARD_SALES_LIST_SUCCESS,
                data,
            });
        }
        catch (error) {
            yield put({
                type: actions.DASHBOARD_SALES_LIST_ERROR,
                error,
            });
        }
    });
}
export function* salesListSuccess() {
    yield takeEvery(actions.DASHBOARD_SALES_LIST_SUCCESS, () => {});
}
export function* salesListError() {
    yield takeEvery(actions.DASHBOARD_SALES_LIST_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Income breakdown
export function* incomeBreakdownRequest() {
    yield takeEvery(actions.DASHBOARD_INCOME_BREAKDOWN_REQUEST, function* ({ request }, context) {
        try {
            const response = yield call(get, '/dashboard/income_breakdown', request, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.DASHBOARD_INCOME_BREAKDOWN_SUCCESS,
                data,
            });
        }
        catch (error) {
            yield put({
                type: actions.DASHBOARD_INCOME_BREAKDOWN_ERROR,
                error,
            });
        }
    });
}
export function* incomeBreakdownSuccess() {
    yield takeEvery(actions.DASHBOARD_INCOME_BREAKDOWN_SUCCESS, () => {});
}
export function* incomeBreakdownError() {
    yield takeEvery(actions.DASHBOARD_INCOME_BREAKDOWN_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Expense breakdown
export function* expenseBreakdownRequest() {
    yield takeEvery(actions.DASHBOARD_EXPENSE_BREAKDOWN_REQUEST, function* ({ request }, context) {
        try {
            const response = yield call(get, '/dashboard/expense_breakdown', request, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.DASHBOARD_EXPENSE_BREAKDOWN_SUCCESS,
                data,
            });
        }
        catch (error) {
            yield put({
                type: actions.DASHBOARD_EXPENSE_BREAKDOWN_ERROR,
                error,
            });
        }
    });
}
export function* expenseBreakdownSuccess() {
    yield takeEvery(actions.DASHBOARD_EXPENSE_BREAKDOWN_SUCCESS, () => {});
}
export function* expenseBreakdownError() {
    yield takeEvery(actions.DASHBOARD_EXPENSE_BREAKDOWN_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

export default function* rootSaga() {
    yield all([
        fork(allRequest),
        fork(allSuccess),
        fork(allError),
        fork(outstandingsRequest),
        fork(outstandingsSuccess),
        fork(outstandingsError),
        fork(salesTrendRequest),
        fork(salesTrendSuccess),
        fork(salesTrendError),
        fork(profitLossTrendRequest),
        fork(profitLossTrendSuccess),
        fork(profitLossTrendError),
        fork(cashflowTrendRequest),
        fork(cashflowTrendSuccess),
        fork(cashflowTrendError),
        fork(cashflowForecastRequest),
        fork(cashflowForecastSuccess),
        fork(cashflowForecastError),
        fork(bankAccountsRequest),
        fork(bankAccountsSuccess),
        fork(bankAccountsError),
        fork(salesListRequest),
        fork(salesListSuccess),
        fork(salesListError),
        fork(incomeBreakdownRequest),
        fork(incomeBreakdownSuccess),
        fork(incomeBreakdownError),
        fork(expenseBreakdownRequest),
        fork(expenseBreakdownSuccess),
        fork(expenseBreakdownError),
    ]);
}
